import { defineMessages } from 'react-intl';

export default defineMessages({
    whatExpensesAreYouClaimingFor: {
    id: 'fastCover.medicalAndEvacuationSCTIStep.whatExpensesAreYouClaimingFor',
    defaultMessage: 'What expenses are you claiming for?',
  },
  repatriationBenefitReturnOfRemains: {
    id: 'fastCover.stepOtherTugo.repatriationBenefitReturnOfRemains',
    defaultMessage: 'Repatriation Benefit (Return of Remains)',
  },
  repatriationBurialAtPlaceOfDeath: {
    id: 'fastCover.stepOtherTugo.repatriationBurialAtPlaceOfDeath',
    defaultMessage: 'Repatriation (Burial at place of death)',
  },
  returnHomeBenefit: {
    id: 'fastCover.stepOtherTugo.returnHomeBenefit',
    defaultMessage: 'Return Home Benefit',
  },
    amountClaimed: {
    id: 'fastCover.stepOtherTugo.amountClaimed',
    defaultMessage: 'Amount claimed',
  },
    currency: {
    id: 'fastCover.stepOtherTugo.currency',
    defaultMessage: 'Currency',
  },
  selectInsuredForExpense: {
    id: 'fastCover.stepOtherTugo.selectInsuredForExpense',
    defaultMessage: 'Select the insured for this expense',
  },
   expenseFor: {
    id: 'fastCover.stepOtherTugo.expenseFor',
    defaultMessage: 'Expense For',
  },
  descriptionOfExpense: {
    id: 'fastCover.stepOtherTugo.descriptionOfExpense',
    defaultMessage: 'Description of Expense',
  },
    isRequired: {
    id: 'fastCover.stepOtherTugo.isRequired',
    defaultMessage: '\'{defaultMessage}\' is required',
  },
    addItem: {
    id: 'fastCover.stepOtherTugo.addItem',
    defaultMessage: 'Add Expense',
  },
    dateOfExpenses: {
    id: 'fastCover.stepOtherTugo.dateOfExpenses',
    defaultMessage: 'Date of Expense',
  },
});



// WEBPACK FOOTER //
// ./app/containers/FastCover/Tugo.StepOther/messages.js